module.exports = __webpack_public_path__ + "img/iconDownloadNavy.a97c94a4.svg";